import React, { ReactNode, ReactElement } from 'react';
import { Box, IBoxProps } from '@styleseat/ui';
import { BodyText } from '..';

import './Bullet.module.scss';

export type BulletProps = IBoxProps & {
  bulletIcon?: ReactNode,
  bulletColor?: string,
};

/**
 * A bullet point unordered list item.
 */
const Bullet: React.FC<BulletProps> = ({
  bulletColor,
  bulletIcon = <BodyText styleName="bullet__point" color={bulletColor}>•</BodyText>,
  children,
  ...rest
}): ReactElement => (
  <Box flexDirection="row" {...rest}>
    <Box>
      {bulletIcon}
    </Box>
    <Box flex={1}>
      {typeof children === 'string' ? <BodyText>{children}</BodyText> : children}
    </Box>
  </Box>
);

export default Bullet;
